/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecuteGraphRequestRequest
 */
export interface ExecuteGraphRequestRequest {
    /**
     * 
     */
    url: string;
    /**
     * 
     */
    client: string;
    /**
     * 
     */
    properties?: string;
    /**
     * 
     */
    requestType: string;
    /**
     * 
     */
    apiVersion: string;
}

/**
 * Check if a given object implements the ExecuteGraphRequestRequest interface.
 */
export function instanceOfExecuteGraphRequestRequest(value: object): value is ExecuteGraphRequestRequest {
    if (!('url' in value) || value['url'] === undefined) return false;
    if (!('client' in value) || value['client'] === undefined) return false;
    if (!('requestType' in value) || value['requestType'] === undefined) return false;
    if (!('apiVersion' in value) || value['apiVersion'] === undefined) return false;
    return true;
}

export function ExecuteGraphRequestRequestFromJSON(json: any): ExecuteGraphRequestRequest {
    return ExecuteGraphRequestRequestFromJSONTyped(json, false);
}

export function ExecuteGraphRequestRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecuteGraphRequestRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'],
        'client': json['client'],
        'properties': json['properties'] == null ? undefined : json['properties'],
        'requestType': json['requestType'],
        'apiVersion': json['apiVersion'],
    };
}

export function ExecuteGraphRequestRequestToJSON(json: any): ExecuteGraphRequestRequest {
    return ExecuteGraphRequestRequestToJSONTyped(json, false);
}

export function ExecuteGraphRequestRequestToJSONTyped(value?: ExecuteGraphRequestRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'url': value['url'],
        'client': value['client'],
        'properties': value['properties'],
        'requestType': value['requestType'],
        'apiVersion': value['apiVersion'],
    };
}

